import { render } from "./CustomerDetails.vue?vue&type=template&id=2c1b195a&scoped=true"
import script from "./CustomerDetails.vue?vue&type=script&lang=js"
export * from "./CustomerDetails.vue?vue&type=script&lang=js"

import exportComponent from "/home/q4-cockpitmdwareorg/q4-cockpit.mdware.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1b195a"]])

export default __exports__